import { createContext, useContext } from 'react';

export interface RadioGroupContextValue {
  /**
   * Items report themselves so the group can size its column grid. Reading
   * `children` cannot do this: items are usually produced by `.map`, so their
   * props are invisible to the group.
   */
  registerItem(id: string): () => void;
  /** Descriptions report separately, because they drive the column count. */
  registerDescription(id: string): () => void;
}

export const RadioGroupContext = createContext<RadioGroupContextValue | null>(
  null
);

export function useRadioGroupContext(): RadioGroupContextValue {
  const context = useContext(RadioGroupContext);

  if (!context) {
    throw new Error(
      'RadioGroup sub-components must be rendered inside a <RadioGroup>.'
    );
  }

  return context;
}

export interface RadioItemContextValue {
  id: string;
}

export const RadioItemContext = createContext<RadioItemContextValue | null>(
  null
);

export function useRadioItemContext(): RadioItemContextValue {
  const context = useContext(RadioItemContext);

  if (!context) {
    throw new Error(
      'RadioGroup item parts must be rendered inside a <RadioGroup.Item>.'
    );
  }

  return context;
}
